import React, { Component } from 'react';
// import { withRouter } from 'react-router';
// import {Input, Label, Button, Collapse, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';

import Logic from '../../Logic';

class Report extends Component {
    constructor(props) {
        super(props);
        this.state = 
        {
        };
    }
    
    componentDidMount(){
        
    }

    render(){
        return (
            <div>
                {this.props.init ?
                <>
                <div>כמות מועמדים פעילים</div>
                <div>כמות מועמדים בשירות עצמי</div>
                <div>כמות מועמדים בשירות מלא</div>
                <div>פילוח מועמדים לפי ספק</div>
                <div>פילוח מועמדים לפי סביבת העסקה</div>
                <div>פילוח מועמדים לפי נאמן ביטחון</div>
                </> : null}
            </div>
        );
    }
  };
  
export default Report;